module.exports = __webpack_public_path__ + "static/dad-fd3d117a4989347ca8c37947cf8f993b.jpeg";